module.exports = __webpack_public_path__ + "media/images/flags@2x-9d5328fb490cddd43f6698012123404b.png";